<h1 i18n>Neue Veranstaltung erstellen</h1>
@if (baseEvent) {
  <p i18n>Der Fragebogen wird von der Veranstaltung „{{ baseEvent.name }}“ übernommen.</p>
}
<form [formGroup]="eventForm" (ngSubmit)="submit()">
  <dt-event-configuration></dt-event-configuration>

  <button mat-raised-button color="primary" [disabled]="eventForm.invalid || eventForm.disabled" [dtOverlayProgress]="eventForm.disabled">
    <mat-icon>add_circle</mat-icon><ng-container i18n>Veranstaltung erstellen</ng-container>
  </button>
  <button mat-raised-button type="button" [disabled]="eventForm.disabled" (click)="cancel()">
    <mat-icon>cancel</mat-icon><ng-container i18n>Abbrechen</ng-container>
  </button>
</form>
